import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A type representing BigDecimal */
  BigDecimal: { input: any; output: any; }
  Instant: { input: any; output: any; }
  /** A type representing local date */
  LocalDate: { input: any; output: any; }
  /** A type representing long */
  Long: { input: any; output: any; }
  /** A type representing a string identifier */
  UUID: { input: any; output: any; }
};

export enum AnswerScale {
  YesNo = 'YES_NO',
  YesNoNotSure = 'YES_NO_NOT_SURE'
}

export enum CalcDrugFrequencyPeriod {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum CsgGender {
  F = 'F',
  M = 'M'
}

export type DeclinableDrugAnswerOutput = {
  __typename?: 'DeclinableDrugAnswerOutput';
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  brandNames?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  condition?: Maybe<Scalars['String']['output']>;
  drugId: Scalars['UUID']['output'];
  drugName: Scalars['String']['output'];
  genericName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  naic: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Instant']['output'];
};

export type DeclinableDrugInput = {
  brandNames?: InputMaybe<Scalars['String']['input']>;
  condition?: InputMaybe<Scalars['String']['input']>;
  drugListId: Scalars['UUID']['input'];
  drugName: Scalars['String']['input'];
  genericName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type DeclinableDrugListInput = {
  carrierDisplayName?: InputMaybe<Scalars['String']['input']>;
  extraRules?: InputMaybe<Scalars['String']['input']>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  guideDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  listScope?: InputMaybe<Scalars['String']['input']>;
  naic: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceDocument?: InputMaybe<Scalars['String']['input']>;
};

export type DeclinableDrugListOutput = {
  __typename?: 'DeclinableDrugListOutput';
  carrierDisplayName?: Maybe<Scalars['String']['output']>;
  drugs: Array<DeclinableDrugOutput>;
  extraRules?: Maybe<Scalars['String']['output']>;
  filterName?: Maybe<Scalars['String']['output']>;
  guideDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  listScope?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<Scalars['String']['output']>;
};

export type DeclinableDrugOutput = {
  __typename?: 'DeclinableDrugOutput';
  brandNames?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  drugName: Scalars['String']['output'];
  genericName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export enum Disposition {
  Disqualifying = 'DISQUALIFYING',
  Informational = 'INFORMATIONAL',
  None = 'NONE',
  NonDisqualifying = 'NON_DISQUALIFYING',
  UnderwritingReview = 'UNDERWRITING_REVIEW'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export type MedigapCompanyFilterItem = {
  __typename?: 'MedigapCompanyFilterItem';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  naics: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type MedigapCompanyOutput = {
  __typename?: 'MedigapCompanyOutput';
  fullName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  naic: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCompanyName: Scalars['String']['output'];
};

export enum MedigapDrugDeliveryType {
  Both = 'BOTH',
  Mail = 'MAIL',
  Pharmacy = 'PHARMACY'
}

export type MedigapFilterItem = {
  __typename?: 'MedigapFilterItem';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MedigapFilterStateInput = {
  age: Scalars['Int']['input'];
  benefits?: InputMaybe<Array<MedigapPlanBenefit>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  gender: Gender;
  id?: InputMaybe<Scalars['UUID']['input']>;
  monthlyPlanPremiumRanges?: InputMaybe<Array<Scalars['String']['input']>>;
  planCategory?: InputMaybe<Scalars['String']['input']>;
  planNames?: InputMaybe<Array<MedigapPlanName>>;
  tobacco: Scalars['Boolean']['input'];
  zip: Scalars['String']['input'];
};

export type MedigapFilterStateOutput = {
  __typename?: 'MedigapFilterStateOutput';
  age: Scalars['Int']['output'];
  benefits?: Maybe<Array<MedigapPlanBenefit>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  county?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  gender: Gender;
  id: Scalars['UUID']['output'];
  monthlyPlanPremiumRanges?: Maybe<Array<Scalars['String']['output']>>;
  planCategory?: Maybe<Scalars['String']['output']>;
  planNames?: Maybe<Array<MedigapPlanName>>;
  tobacco: Scalars['Boolean']['output'];
  zip: Scalars['String']['output'];
};

export enum MedigapFrequencyPeriodOutput {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export type MedigapMaBestRatingOutput = {
  __typename?: 'MedigapMaBestRatingOutput';
  amBestRating?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  parentOrgName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
};

export enum MedigapPlanBenefit {
  ForeignTravelEmergency = 'FOREIGN_TRAVEL_EMERGENCY',
  PartADeductible = 'PART_A_DEDUCTIBLE',
  PartBDeductible = 'PART_B_DEDUCTIBLE',
  PartBExcessCharges = 'PART_B_EXCESS_CHARGES',
  SkilledNursingFacilities = 'SKILLED_NURSING_FACILITIES'
}

export enum MedigapPlanName {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  Hdf = 'HDF',
  Hdg = 'HDG',
  I = 'I',
  K = 'K',
  L = 'L',
  M = 'M',
  MaCore = 'MA_CORE',
  MaSupp1 = 'MA_SUPP1',
  MaSupp1A = 'MA_SUPP1A',
  MnrExcs = 'MNR_EXCS',
  MnrPrev = 'MNR_PREV',
  MnrPta = 'MNR_PTA',
  MnrPtb = 'MNR_PTB',
  MnrUhc1 = 'MNR_UHC1',
  MnrUprv = 'MNR_UPRV',
  MnBasic = 'MN_BASIC',
  MnExtb = 'MN_EXTB',
  MnHded = 'MN_HDED',
  MnHded2 = 'MN_HDED2',
  MnPbco = 'MN_PBCO',
  MnXbas = 'MN_XBAS',
  N = 'N',
  WiHded = 'WI_HDED'
}

export type MedigapPlanOutput = {
  __typename?: 'MedigapPlanOutput';
  amBestRating?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  duplicates?: Maybe<Array<MedigapPlanOutput>>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  householdDiscount?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  monthlyPremium?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  orgName?: Maybe<Scalars['String']['output']>;
  parentOrgName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  ratingClass?: Maybe<Scalars['String']['output']>;
  showAdditionalBenefitsDescription: Scalars['Boolean']['output'];
  spRating?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MedigapPlanRateOutput = {
  __typename?: 'MedigapPlanRateOutput';
  carrier?: Maybe<Scalars['String']['output']>;
  female65PriceMax?: Maybe<Scalars['BigDecimal']['output']>;
  female65PriceMin?: Maybe<Scalars['BigDecimal']['output']>;
  female75PriceMax?: Maybe<Scalars['BigDecimal']['output']>;
  female75PriceMin?: Maybe<Scalars['BigDecimal']['output']>;
  householdPercentMax?: Maybe<Scalars['BigDecimal']['output']>;
  householdPercentMin?: Maybe<Scalars['BigDecimal']['output']>;
  male65PriceMax?: Maybe<Scalars['BigDecimal']['output']>;
  male65PriceMin?: Maybe<Scalars['BigDecimal']['output']>;
  male75PriceMax?: Maybe<Scalars['BigDecimal']['output']>;
  male75PriceMin?: Maybe<Scalars['BigDecimal']['output']>;
};

export enum MedigapPlansField {
  MonthlyPremium = 'MONTHLY_PREMIUM',
  PlanName = 'PLAN_NAME'
}

export type MedigapPlansFilterInput = {
  age: Scalars['Int']['input'];
  benefits?: InputMaybe<Array<MedigapPlanBenefit>>;
  companies: Array<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  gender: Gender;
  monthlyPlanPremiumRanges: Array<Scalars['String']['input']>;
  planNames: Array<MedigapPlanName>;
  tobacco: Scalars['Boolean']['input'];
  zip: Scalars['String']['input'];
};

export type MedigapPlansSortInput = {
  direction: Sort;
  field: MedigapPlansField;
};

export type MedigapPreferredDrugOutput = {
  __typename?: 'MedigapPreferredDrugOutput';
  dosageRxcui: Scalars['String']['output'];
  frequency: CalcDrugFrequencyPeriod;
  productRxcui: Scalars['String']['output'];
  purchaseFrequency: MedigapFrequencyPeriodOutput;
  quantity: Scalars['BigDecimal']['output'];
};

export type MedigapPremiumRange = {
  __typename?: 'MedigapPremiumRange';
  planName: MedigapPlanName;
  rangeDescription: Scalars['String']['output'];
};

export type MedigapQuoteInput = {
  cId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  medigapFilterState: MedigapFilterStateInput;
};

export type MedigapQuoteOutput = {
  __typename?: 'MedigapQuoteOutput';
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  drugDeliveryType?: Maybe<MedigapDrugDeliveryType>;
  id: Scalars['UUID']['output'];
  medigapFilterState: MedigapFilterStateOutput;
  preferredDrugs: Array<MedigapPreferredDrugOutput>;
  preferredPharmacies: Array<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createMedigapQuoteForClient: SaveMedigapQuoteOutput;
  createMedigapQuoteFromMedicareQuote: SaveMedigapQuoteOutput;
  deleteDeclinableDrug: Scalars['Boolean']['output'];
  deleteDeclinableDrugList: Scalars['Boolean']['output'];
  deleteUnderwritingAnswer: Scalars['Boolean']['output'];
  deleteUnderwritingQuestion: Scalars['Boolean']['output'];
  deleteUnderwritingQuestionSet: Scalars['Boolean']['output'];
  disableUnderwritingAnswersForCarrier: Scalars['Boolean']['output'];
  saveDeclinableDrug: Scalars['UUID']['output'];
  saveDeclinableDrugAnswers: Array<DeclinableDrugAnswerOutput>;
  saveDeclinableDrugList: Scalars['UUID']['output'];
  saveMedigapFilterState: Scalars['UUID']['output'];
  saveMedigapQuote: SaveMedigapQuoteOutput;
  saveUnderwritingAnswers: Array<UnderwritingAnswerOutput>;
  saveUnderwritingClientNote: UnderwritingClientNoteOutput;
  saveUnderwritingQuestion: Scalars['UUID']['output'];
  saveUnderwritingQuestionSet: Scalars['UUID']['output'];
};


export type MutationCreateMedigapQuoteForClientArgs = {
  agentOffer?: InputMaybe<Scalars['Boolean']['input']>;
  input: MedigapQuoteInput;
};


export type MutationCreateMedigapQuoteFromMedicareQuoteArgs = {
  medicareQuoteId: Scalars['UUID']['input'];
};


export type MutationDeleteDeclinableDrugArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeclinableDrugListArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUnderwritingAnswerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUnderwritingQuestionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUnderwritingQuestionSetArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDisableUnderwritingAnswersForCarrierArgs = {
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
};


export type MutationSaveDeclinableDrugArgs = {
  input: DeclinableDrugInput;
};


export type MutationSaveDeclinableDrugAnswersArgs = {
  input: SaveDeclinableDrugAnswersInput;
};


export type MutationSaveDeclinableDrugListArgs = {
  input: DeclinableDrugListInput;
};


export type MutationSaveMedigapFilterStateArgs = {
  input: MedigapFilterStateInput;
};


export type MutationSaveMedigapQuoteArgs = {
  input: MedigapQuoteInput;
};


export type MutationSaveUnderwritingAnswersArgs = {
  input: SaveUnderwritingAnswersInput;
};


export type MutationSaveUnderwritingClientNoteArgs = {
  input: SaveUnderwritingClientNoteInput;
};


export type MutationSaveUnderwritingQuestionArgs = {
  input: UnderwritingQuestionInput;
};


export type MutationSaveUnderwritingQuestionSetArgs = {
  input: UnderwritingQuestionSetInput;
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PageableMedigapPlanOutput = {
  __typename?: 'PageableMedigapPlanOutput';
  data: Array<MedigapPlanOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PlanPriceByMonthOutput = {
  __typename?: 'PlanPriceByMonthOutput';
  month: Scalars['LocalDate']['output'];
  monthlyPremium?: Maybe<Scalars['BigDecimal']['output']>;
  parentOrgName?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  buildMedigapPlanAmBestRatingReport: Array<MedigapMaBestRatingOutput>;
  declinableDrugAnswers: Array<DeclinableDrugAnswerOutput>;
  declinableDrugList?: Maybe<DeclinableDrugListOutput>;
  declinableDrugLists: Array<DeclinableDrugListOutput>;
  medigapBenefits: Array<MedigapFilterItem>;
  medigapCompanies: Array<MedigapCompanyFilterItem>;
  medigapCompaniesUnfiltered: Array<MedigapCompanyFilterItem>;
  medigapCompany?: Maybe<MedigapCompanyOutput>;
  medigapFilterState: MedigapFilterStateOutput;
  medigapMonthlyPlanPremium: Array<MedigapFilterItem>;
  medigapPlan: MedigapPlanOutput;
  medigapPlanNames: Array<MedigapFilterItem>;
  medigapPlanRates: Array<MedigapPlanRateOutput>;
  medigapPlans: PageableMedigapPlanOutput;
  medigapPlansUnfiltered: PageableMedigapPlanOutput;
  medigapPremiumRanges: Array<MedigapPremiumRange>;
  medigapQuote: MedigapQuoteOutput;
  mgPlansSort?: Maybe<MedigapPlansField>;
  mgPlansTotal?: Maybe<Scalars['Int']['output']>;
  planPricesByMonth: Array<PlanPriceByMonthOutput>;
  underwritingAnswers: Array<UnderwritingAnswerOutput>;
  underwritingClientNote?: Maybe<UnderwritingClientNoteOutput>;
  underwritingQuestionSet?: Maybe<UnderwritingQuestionSetOutput>;
  underwritingQuestionSets: Array<UnderwritingQuestionSetOutput>;
};


export type QueryBuildMedigapPlanAmBestRatingReportArgs = {
  code: Scalars['String']['input'];
};


export type QueryDeclinableDrugAnswersArgs = {
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
};


export type QueryDeclinableDrugListArgs = {
  naic?: InputMaybe<Scalars['String']['input']>;
  naics?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMedigapCompaniesArgs = {
  filter: MedigapPlansFilterInput;
};


export type QueryMedigapCompaniesUnfilteredArgs = {
  filter: MedigapPlansFilterInput;
};


export type QueryMedigapCompanyArgs = {
  naic: Scalars['String']['input'];
};


export type QueryMedigapFilterStateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMedigapPlanArgs = {
  key: Scalars['String']['input'];
};


export type QueryMedigapPlanNamesArgs = {
  filter: MedigapPlansFilterInput;
};


export type QueryMedigapPlanRatesArgs = {
  planName: MedigapPlanName;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMedigapPlansArgs = {
  filter: MedigapPlansFilterInput;
  page: PageInput;
  sort?: InputMaybe<Array<MedigapPlansSortInput>>;
};


export type QueryMedigapPlansUnfilteredArgs = {
  filter: MedigapPlansFilterInput;
  page: PageInput;
  sort?: InputMaybe<Array<MedigapPlansSortInput>>;
};


export type QueryMedigapPremiumRangesArgs = {
  age: Scalars['Int']['input'];
  gender: CsgGender;
  tobacco: Scalars['Boolean']['input'];
  zip: Scalars['String']['input'];
};


export type QueryMedigapQuoteArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPlanPricesByMonthArgs = {
  planName: MedigapPlanName;
};


export type QueryUnderwritingAnswersArgs = {
  clientId: Scalars['UUID']['input'];
  naic?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnderwritingClientNoteArgs = {
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
};


export type QueryUnderwritingQuestionSetArgs = {
  naic?: InputMaybe<Scalars['String']['input']>;
  naics?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionType {
  Note = 'NOTE',
  Question = 'QUESTION',
  Section = 'SECTION',
  Subitem = 'SUBITEM'
}

export type SaveDeclinableDrugAnswersInput = {
  clientId: Scalars['UUID']['input'];
  drugIds: Array<Scalars['UUID']['input']>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
};

export type SaveMedigapQuoteOutput = {
  __typename?: 'SaveMedigapQuoteOutput';
  clientId: Scalars['UUID']['output'];
  mgQuoteId: Scalars['UUID']['output'];
};

export type SaveUnderwritingAnswersInput = {
  answers: Array<UnderwritingAnswerInput>;
  clientId: Scalars['UUID']['input'];
  filterName?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
};

export type SaveUnderwritingClientNoteInput = {
  clientId: Scalars['UUID']['input'];
  filterName?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export enum ShowWhenParentAnswer {
  Always = 'ALWAYS',
  No = 'NO',
  Yes = 'YES'
}

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type UnderwritingAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  questionId: Scalars['UUID']['input'];
};

export type UnderwritingAnswerOutput = {
  __typename?: 'UnderwritingAnswerOutput';
  answer?: Maybe<Scalars['String']['output']>;
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  naic: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  questionId: Scalars['UUID']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export enum UnderwritingApproach {
  GuaranteedIssue = 'GUARANTEED_ISSUE',
  Other = 'OTHER',
  UnderwrittenUnlessOeGi = 'UNDERWRITTEN_UNLESS_OE_GI'
}

export type UnderwritingClientNoteOutput = {
  __typename?: 'UnderwritingClientNoteOutput';
  answeredByEmail?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  naic: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Instant']['output'];
};

export type UnderwritingQuestionInput = {
  answerScale?: InputMaybe<AnswerScale>;
  answerable: Scalars['Boolean']['input'];
  appliesWhen?: InputMaybe<Scalars['String']['input']>;
  displayOrder: Scalars['Int']['input'];
  disposition: Disposition;
  id?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  questionSetId: Scalars['UUID']['input'];
  showWhenParentAnswer: ShowWhenParentAnswer;
  text: Scalars['String']['input'];
  type: QuestionType;
};

export type UnderwritingQuestionOutput = {
  __typename?: 'UnderwritingQuestionOutput';
  answerScale?: Maybe<AnswerScale>;
  answerable: Scalars['Boolean']['output'];
  appliesWhen?: Maybe<Scalars['String']['output']>;
  children: Array<UnderwritingQuestionOutput>;
  displayOrder: Scalars['Int']['output'];
  disposition: Disposition;
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['UUID']['output']>;
  showWhenParentAnswer: ShowWhenParentAnswer;
  text: Scalars['String']['output'];
  type: QuestionType;
};

export type UnderwritingQuestionSetInput = {
  answerScale: AnswerScale;
  carrierDisplayName?: InputMaybe<Scalars['String']['input']>;
  filterName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  skipsIfOeGi: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  underwritingApproach?: InputMaybe<UnderwritingApproach>;
};

export type UnderwritingQuestionSetOutput = {
  __typename?: 'UnderwritingQuestionSetOutput';
  answerScale: AnswerScale;
  carrierDisplayName?: Maybe<Scalars['String']['output']>;
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  naic: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  questions: Array<UnderwritingQuestionOutput>;
  skipsIfOeGi: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  underwritingApproach?: Maybe<UnderwritingApproach>;
};

export enum UserRole {
  RoleAdmin = 'ROLE_ADMIN',
  RoleAdviser = 'ROLE_ADVISER',
  RoleNone = 'ROLE_NONE',
  RoleTechStaff = 'ROLE_TECH_STAFF',
  RoleUnauthorized = 'ROLE_UNAUTHORIZED',
  RoleUser = 'ROLE_USER'
}

export type MedigapPlanRatesQueryVariables = Exact<{
  planName: MedigapPlanName;
}>;


export type MedigapPlanRatesQuery = { __typename?: 'Query', medigapPlanRates: Array<{ __typename?: 'MedigapPlanRateOutput', carrier?: string | null, female65PriceMax?: any | null, female65PriceMin?: any | null, female75PriceMax?: any | null, female75PriceMin?: any | null, householdPercentMax?: any | null, householdPercentMin?: any | null, male65PriceMax?: any | null, male65PriceMin?: any | null, male75PriceMax?: any | null, male75PriceMin?: any | null }> };

export type PlanPricesByMonthQueryVariables = Exact<{
  planName: MedigapPlanName;
}>;


export type PlanPricesByMonthQuery = { __typename?: 'Query', planPricesByMonth: Array<{ __typename?: 'PlanPriceByMonthOutput', month: any, monthlyPremium?: any | null, parentOrgName?: string | null }> };

export type MgPlansSortQueryVariables = Exact<{ [key: string]: never; }>;


export type MgPlansSortQuery = { __typename?: 'Query', mgPlansSort?: MedigapPlansField | null };

export type MgPlansTotalQueryVariables = Exact<{ [key: string]: never; }>;


export type MgPlansTotalQuery = { __typename?: 'Query', mgPlansTotal?: number | null };

export type SaveMedigapFilterStateMutationVariables = Exact<{
  input: MedigapFilterStateInput;
}>;


export type SaveMedigapFilterStateMutation = { __typename?: 'Mutation', saveMedigapFilterState: any };

export type MedigapFiltersQueryVariables = Exact<{
  filter: MedigapPlansFilterInput;
}>;


export type MedigapFiltersQuery = { __typename?: 'Query', medigapBenefits: Array<{ __typename?: 'MedigapFilterItem', key: string, name: string }>, medigapMonthlyPlanPremium: Array<{ __typename?: 'MedigapFilterItem', key: string, name: string }>, medigapPlanNames: Array<{ __typename?: 'MedigapFilterItem', key: string, name: string, count: number }>, medigapCompanies: Array<{ __typename?: 'MedigapCompanyFilterItem', key: string, name: string, count: number, naics: Array<string> }> };

export type CreateMedigapQuoteFromMedicareQuoteMutationVariables = Exact<{
  medicareQuoteId: Scalars['UUID']['input'];
}>;


export type CreateMedigapQuoteFromMedicareQuoteMutation = { __typename?: 'Mutation', createMedigapQuoteFromMedicareQuote: { __typename?: 'SaveMedigapQuoteOutput', clientId: any, mgQuoteId: any } };

export type MedigapPremiumRangesQueryVariables = Exact<{
  zip: Scalars['String']['input'];
  tobacco: Scalars['Boolean']['input'];
  age: Scalars['Int']['input'];
  gender: CsgGender;
}>;


export type MedigapPremiumRangesQuery = { __typename?: 'Query', medigapPremiumRanges: Array<{ __typename?: 'MedigapPremiumRange', planName: MedigapPlanName, rangeDescription: string }> };

export type MedigapPlansQueryVariables = Exact<{
  filter: MedigapPlansFilterInput;
  page: PageInput;
  sort?: InputMaybe<Array<MedigapPlansSortInput> | MedigapPlansSortInput>;
}>;


export type MedigapPlansQuery = { __typename?: 'Query', medigapPlans: { __typename?: 'PageableMedigapPlanOutput', totalElements: any, data: Array<{ __typename?: 'MedigapPlanOutput', amBestRating?: string | null, householdDiscount?: string | null, key: string, monthlyPremium?: string | null, orgName?: string | null, parentOrgName?: string | null, title?: string | null, subTitle?: string | null, naic: string, spRating?: string | null, ratingClass?: string | null, planName?: string | null, showAdditionalBenefitsDescription: boolean, disclaimer?: string | null }> } };

export type SaveMedigapQuoteMutationVariables = Exact<{
  input: MedigapQuoteInput;
}>;


export type SaveMedigapQuoteMutation = { __typename?: 'Mutation', saveMedigapQuote: { __typename?: 'SaveMedigapQuoteOutput', clientId: any, mgQuoteId: any } };

export type MedigapCompanyQueryVariables = Exact<{
  naic: Scalars['String']['input'];
}>;


export type MedigapCompanyQuery = { __typename?: 'Query', medigapCompany?: { __typename?: 'MedigapCompanyOutput', parentCompanyName: string, name: string } | null };

export type MedigapCompaniesQueryVariables = Exact<{
  filters: MedigapPlansFilterInput;
}>;


export type MedigapCompaniesQuery = { __typename?: 'Query', medigapCompanies: Array<{ __typename?: 'MedigapCompanyFilterItem', key: string, name: string, count: number, naics: Array<string> }> };

export type MedigapQuoteQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MedigapQuoteQuery = { __typename?: 'Query', medigapQuote: { __typename?: 'MedigapQuoteOutput', cId?: string | null, id: any, clientId: any, drugDeliveryType?: MedigapDrugDeliveryType | null, preferredPharmacies: Array<string>, userId?: any | null, preferredDrugs: Array<{ __typename?: 'MedigapPreferredDrugOutput', dosageRxcui: string, frequency: CalcDrugFrequencyPeriod, productRxcui: string, purchaseFrequency: MedigapFrequencyPeriodOutput, quantity: any }>, medigapFilterState: { __typename?: 'MedigapFilterStateOutput', age: number, benefits?: Array<MedigapPlanBenefit> | null, companies?: Array<string> | null, county?: string | null, effectiveDate?: any | null, gender: Gender, id: any, monthlyPlanPremiumRanges?: Array<string> | null, planCategory?: string | null, planNames?: Array<MedigapPlanName> | null, tobacco: boolean, zip: string } } };

export type UnderwritingQuestionFieldsFragment = { __typename?: 'UnderwritingQuestionOutput', id: any, parentId?: any | null, type: QuestionType, displayOrder: number, text: string, answerable: boolean, answerScale?: AnswerScale | null, disposition: Disposition, showWhenParentAnswer: ShowWhenParentAnswer, appliesWhen?: string | null, note?: string | null };

export type UnderwritingQuestionSetFieldsFragment = { __typename?: 'UnderwritingQuestionSetOutput', id: any, naic: string, filterName?: string | null, state?: string | null, carrierDisplayName?: string | null, answerScale: AnswerScale, underwritingApproach?: UnderwritingApproach | null, skipsIfOeGi: boolean, notes?: string | null };

export type UnderwritingAnswerFieldsFragment = { __typename?: 'UnderwritingAnswerOutput', id: any, clientId: any, naic: string, filterName?: string | null, questionId: any, answer?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any };

export type UnderwritingQuestionSetQueryVariables = Exact<{
  naic?: InputMaybe<Scalars['String']['input']>;
  naics?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnderwritingQuestionSetQuery = { __typename?: 'Query', underwritingQuestionSet?: { __typename?: 'UnderwritingQuestionSetOutput', id: any, naic: string, filterName?: string | null, state?: string | null, carrierDisplayName?: string | null, answerScale: AnswerScale, underwritingApproach?: UnderwritingApproach | null, skipsIfOeGi: boolean, notes?: string | null, questions: Array<{ __typename?: 'UnderwritingQuestionOutput', id: any, parentId?: any | null, type: QuestionType, displayOrder: number, text: string, answerable: boolean, answerScale?: AnswerScale | null, disposition: Disposition, showWhenParentAnswer: ShowWhenParentAnswer, appliesWhen?: string | null, note?: string | null, children: Array<{ __typename?: 'UnderwritingQuestionOutput', id: any, parentId?: any | null, type: QuestionType, displayOrder: number, text: string, answerable: boolean, answerScale?: AnswerScale | null, disposition: Disposition, showWhenParentAnswer: ShowWhenParentAnswer, appliesWhen?: string | null, note?: string | null, children: Array<{ __typename?: 'UnderwritingQuestionOutput', id: any, parentId?: any | null, type: QuestionType, displayOrder: number, text: string, answerable: boolean, answerScale?: AnswerScale | null, disposition: Disposition, showWhenParentAnswer: ShowWhenParentAnswer, appliesWhen?: string | null, note?: string | null, children: Array<{ __typename?: 'UnderwritingQuestionOutput', id: any, parentId?: any | null, type: QuestionType, displayOrder: number, text: string, answerable: boolean, answerScale?: AnswerScale | null, disposition: Disposition, showWhenParentAnswer: ShowWhenParentAnswer, appliesWhen?: string | null, note?: string | null }> }> }> }> } | null };

export type UnderwritingQuestionSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnderwritingQuestionSetsQuery = { __typename?: 'Query', underwritingQuestionSets: Array<{ __typename?: 'UnderwritingQuestionSetOutput', id: any, naic: string, filterName?: string | null, state?: string | null, carrierDisplayName?: string | null, answerScale: AnswerScale, underwritingApproach?: UnderwritingApproach | null, skipsIfOeGi: boolean, notes?: string | null, questions: Array<{ __typename?: 'UnderwritingQuestionOutput', id: any }> }> };

export type UnderwritingAnswersQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  naic?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnderwritingAnswersQuery = { __typename?: 'Query', underwritingAnswers: Array<{ __typename?: 'UnderwritingAnswerOutput', id: any, clientId: any, naic: string, filterName?: string | null, questionId: any, answer?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any }> };

export type SaveUnderwritingAnswersMutationVariables = Exact<{
  input: SaveUnderwritingAnswersInput;
}>;


export type SaveUnderwritingAnswersMutation = { __typename?: 'Mutation', saveUnderwritingAnswers: Array<{ __typename?: 'UnderwritingAnswerOutput', id: any, clientId: any, naic: string, filterName?: string | null, questionId: any, answer?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any }> };

export type DeleteUnderwritingAnswerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUnderwritingAnswerMutation = { __typename?: 'Mutation', deleteUnderwritingAnswer: boolean };

export type DisableUnderwritingAnswersForCarrierMutationVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
}>;


export type DisableUnderwritingAnswersForCarrierMutation = { __typename?: 'Mutation', disableUnderwritingAnswersForCarrier: boolean };

export type SaveUnderwritingQuestionSetMutationVariables = Exact<{
  input: UnderwritingQuestionSetInput;
}>;


export type SaveUnderwritingQuestionSetMutation = { __typename?: 'Mutation', saveUnderwritingQuestionSet: any };

export type SaveUnderwritingQuestionMutationVariables = Exact<{
  input: UnderwritingQuestionInput;
}>;


export type SaveUnderwritingQuestionMutation = { __typename?: 'Mutation', saveUnderwritingQuestion: any };

export type DeleteUnderwritingQuestionSetMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUnderwritingQuestionSetMutation = { __typename?: 'Mutation', deleteUnderwritingQuestionSet: boolean };

export type DeleteUnderwritingQuestionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUnderwritingQuestionMutation = { __typename?: 'Mutation', deleteUnderwritingQuestion: boolean };

export type DeclinableDrugListFieldsFragment = { __typename?: 'DeclinableDrugListOutput', id: any, naic: string, filterName?: string | null, carrierDisplayName?: string | null, sourceDocument?: string | null, guideDate?: string | null, listScope?: string | null, extraRules?: string | null, notes?: string | null, drugs: Array<{ __typename?: 'DeclinableDrugOutput', id: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null }> };

export type DeclinableDrugListQueryVariables = Exact<{
  naics?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeclinableDrugListQuery = { __typename?: 'Query', declinableDrugList?: { __typename?: 'DeclinableDrugListOutput', id: any, naic: string, filterName?: string | null, carrierDisplayName?: string | null, sourceDocument?: string | null, guideDate?: string | null, listScope?: string | null, extraRules?: string | null, notes?: string | null, drugs: Array<{ __typename?: 'DeclinableDrugOutput', id: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null }> } | null };

export type DeclinableDrugListsQueryVariables = Exact<{ [key: string]: never; }>;


export type DeclinableDrugListsQuery = { __typename?: 'Query', declinableDrugLists: Array<{ __typename?: 'DeclinableDrugListOutput', id: any, naic: string, filterName?: string | null, carrierDisplayName?: string | null, sourceDocument?: string | null, guideDate?: string | null, listScope?: string | null, extraRules?: string | null, notes?: string | null, drugs: Array<{ __typename?: 'DeclinableDrugOutput', id: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null }> }> };

export type SaveDeclinableDrugListMutationVariables = Exact<{
  input: DeclinableDrugListInput;
}>;


export type SaveDeclinableDrugListMutation = { __typename?: 'Mutation', saveDeclinableDrugList: any };

export type DeleteDeclinableDrugListMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteDeclinableDrugListMutation = { __typename?: 'Mutation', deleteDeclinableDrugList: boolean };

export type SaveDeclinableDrugMutationVariables = Exact<{
  input: DeclinableDrugInput;
}>;


export type SaveDeclinableDrugMutation = { __typename?: 'Mutation', saveDeclinableDrug: any };

export type DeleteDeclinableDrugMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteDeclinableDrugMutation = { __typename?: 'Mutation', deleteDeclinableDrug: boolean };

export type UnderwritingClientNoteFieldsFragment = { __typename?: 'UnderwritingClientNoteOutput', id: any, clientId: any, naic: string, filterName?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any };

export type DeclinableDrugAnswerFieldsFragment = { __typename?: 'DeclinableDrugAnswerOutput', id: any, clientId: any, naic: string, drugId: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any };

export type UnderwritingClientNoteQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
}>;


export type UnderwritingClientNoteQuery = { __typename?: 'Query', underwritingClientNote?: { __typename?: 'UnderwritingClientNoteOutput', id: any, clientId: any, naic: string, filterName?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any } | null };

export type SaveUnderwritingClientNoteMutationVariables = Exact<{
  input: SaveUnderwritingClientNoteInput;
}>;


export type SaveUnderwritingClientNoteMutation = { __typename?: 'Mutation', saveUnderwritingClientNote: { __typename?: 'UnderwritingClientNoteOutput', id: any, clientId: any, naic: string, filterName?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any } };

export type DeclinableDrugAnswersQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  naic: Scalars['String']['input'];
}>;


export type DeclinableDrugAnswersQuery = { __typename?: 'Query', declinableDrugAnswers: Array<{ __typename?: 'DeclinableDrugAnswerOutput', id: any, clientId: any, naic: string, drugId: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any }> };

export type SaveDeclinableDrugAnswersMutationVariables = Exact<{
  input: SaveDeclinableDrugAnswersInput;
}>;


export type SaveDeclinableDrugAnswersMutation = { __typename?: 'Mutation', saveDeclinableDrugAnswers: Array<{ __typename?: 'DeclinableDrugAnswerOutput', id: any, clientId: any, naic: string, drugId: any, drugName: string, genericName?: string | null, brandNames?: string | null, condition?: string | null, note?: string | null, answeredByEmail?: string | null, updatedAt: any }> };

export const UnderwritingQuestionFieldsFragmentDoc = gql`
    fragment UnderwritingQuestionFields on UnderwritingQuestionOutput {
  id
  parentId
  type
  displayOrder
  text
  answerable
  answerScale
  disposition
  showWhenParentAnswer
  appliesWhen
  note
}
    `;
export const UnderwritingQuestionSetFieldsFragmentDoc = gql`
    fragment UnderwritingQuestionSetFields on UnderwritingQuestionSetOutput {
  id
  naic
  filterName
  state
  carrierDisplayName
  answerScale
  underwritingApproach
  skipsIfOeGi
  notes
}
    `;
export const UnderwritingAnswerFieldsFragmentDoc = gql`
    fragment UnderwritingAnswerFields on UnderwritingAnswerOutput {
  id
  clientId
  naic
  filterName
  questionId
  answer
  note
  answeredByEmail
  updatedAt
}
    `;
export const DeclinableDrugListFieldsFragmentDoc = gql`
    fragment DeclinableDrugListFields on DeclinableDrugListOutput {
  id
  naic
  filterName
  carrierDisplayName
  sourceDocument
  guideDate
  listScope
  extraRules
  notes
  drugs {
    id
    drugName
    genericName
    brandNames
    condition
    note
  }
}
    `;
export const UnderwritingClientNoteFieldsFragmentDoc = gql`
    fragment UnderwritingClientNoteFields on UnderwritingClientNoteOutput {
  id
  clientId
  naic
  filterName
  note
  answeredByEmail
  updatedAt
}
    `;
export const DeclinableDrugAnswerFieldsFragmentDoc = gql`
    fragment DeclinableDrugAnswerFields on DeclinableDrugAnswerOutput {
  id
  clientId
  naic
  drugId
  drugName
  genericName
  brandNames
  condition
  note
  answeredByEmail
  updatedAt
}
    `;
export const MedigapPlanRatesDocument = gql`
    query medigapPlanRates($planName: MedigapPlanName!) {
  medigapPlanRates(planName: $planName) {
    carrier
    female65PriceMax
    female65PriceMin
    female75PriceMax
    female75PriceMin
    householdPercentMax
    householdPercentMin
    male65PriceMax
    male65PriceMin
    male75PriceMax
    male75PriceMin
  }
}
    `;

/**
 * __useMedigapPlanRatesQuery__
 *
 * To run a query within a React component, call `useMedigapPlanRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapPlanRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapPlanRatesQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useMedigapPlanRatesQuery(baseOptions: Apollo.QueryHookOptions<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables> & ({ variables: MedigapPlanRatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>(MedigapPlanRatesDocument, options);
      }
export function useMedigapPlanRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>(MedigapPlanRatesDocument, options);
        }
export function useMedigapPlanRatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>(MedigapPlanRatesDocument, options);
        }
export type MedigapPlanRatesQueryHookResult = ReturnType<typeof useMedigapPlanRatesQuery>;
export type MedigapPlanRatesLazyQueryHookResult = ReturnType<typeof useMedigapPlanRatesLazyQuery>;
export type MedigapPlanRatesSuspenseQueryHookResult = ReturnType<typeof useMedigapPlanRatesSuspenseQuery>;
export type MedigapPlanRatesQueryResult = Apollo.QueryResult<MedigapPlanRatesQuery, MedigapPlanRatesQueryVariables>;
export const PlanPricesByMonthDocument = gql`
    query planPricesByMonth($planName: MedigapPlanName!) {
  planPricesByMonth(planName: $planName) {
    month
    monthlyPremium
    parentOrgName
  }
}
    `;

/**
 * __usePlanPricesByMonthQuery__
 *
 * To run a query within a React component, call `usePlanPricesByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPricesByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPricesByMonthQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function usePlanPricesByMonthQuery(baseOptions: Apollo.QueryHookOptions<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables> & ({ variables: PlanPricesByMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>(PlanPricesByMonthDocument, options);
      }
export function usePlanPricesByMonthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>(PlanPricesByMonthDocument, options);
        }
export function usePlanPricesByMonthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>(PlanPricesByMonthDocument, options);
        }
export type PlanPricesByMonthQueryHookResult = ReturnType<typeof usePlanPricesByMonthQuery>;
export type PlanPricesByMonthLazyQueryHookResult = ReturnType<typeof usePlanPricesByMonthLazyQuery>;
export type PlanPricesByMonthSuspenseQueryHookResult = ReturnType<typeof usePlanPricesByMonthSuspenseQuery>;
export type PlanPricesByMonthQueryResult = Apollo.QueryResult<PlanPricesByMonthQuery, PlanPricesByMonthQueryVariables>;
export const MgPlansSortDocument = gql`
    query mgPlansSort {
  mgPlansSort @client
}
    `;

/**
 * __useMgPlansSortQuery__
 *
 * To run a query within a React component, call `useMgPlansSortQuery` and pass it any options that fit your needs.
 * When your component renders, `useMgPlansSortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMgPlansSortQuery({
 *   variables: {
 *   },
 * });
 */
export function useMgPlansSortQuery(baseOptions?: Apollo.QueryHookOptions<MgPlansSortQuery, MgPlansSortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MgPlansSortQuery, MgPlansSortQueryVariables>(MgPlansSortDocument, options);
      }
export function useMgPlansSortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MgPlansSortQuery, MgPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MgPlansSortQuery, MgPlansSortQueryVariables>(MgPlansSortDocument, options);
        }
export function useMgPlansSortSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MgPlansSortQuery, MgPlansSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MgPlansSortQuery, MgPlansSortQueryVariables>(MgPlansSortDocument, options);
        }
export type MgPlansSortQueryHookResult = ReturnType<typeof useMgPlansSortQuery>;
export type MgPlansSortLazyQueryHookResult = ReturnType<typeof useMgPlansSortLazyQuery>;
export type MgPlansSortSuspenseQueryHookResult = ReturnType<typeof useMgPlansSortSuspenseQuery>;
export type MgPlansSortQueryResult = Apollo.QueryResult<MgPlansSortQuery, MgPlansSortQueryVariables>;
export const MgPlansTotalDocument = gql`
    query mgPlansTotal {
  mgPlansTotal @client
}
    `;

/**
 * __useMgPlansTotalQuery__
 *
 * To run a query within a React component, call `useMgPlansTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMgPlansTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMgPlansTotalQuery({
 *   variables: {
 *   },
 * });
 */
export function useMgPlansTotalQuery(baseOptions?: Apollo.QueryHookOptions<MgPlansTotalQuery, MgPlansTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MgPlansTotalQuery, MgPlansTotalQueryVariables>(MgPlansTotalDocument, options);
      }
export function useMgPlansTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MgPlansTotalQuery, MgPlansTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MgPlansTotalQuery, MgPlansTotalQueryVariables>(MgPlansTotalDocument, options);
        }
export function useMgPlansTotalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MgPlansTotalQuery, MgPlansTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MgPlansTotalQuery, MgPlansTotalQueryVariables>(MgPlansTotalDocument, options);
        }
export type MgPlansTotalQueryHookResult = ReturnType<typeof useMgPlansTotalQuery>;
export type MgPlansTotalLazyQueryHookResult = ReturnType<typeof useMgPlansTotalLazyQuery>;
export type MgPlansTotalSuspenseQueryHookResult = ReturnType<typeof useMgPlansTotalSuspenseQuery>;
export type MgPlansTotalQueryResult = Apollo.QueryResult<MgPlansTotalQuery, MgPlansTotalQueryVariables>;
export const SaveMedigapFilterStateDocument = gql`
    mutation saveMedigapFilterState($input: MedigapFilterStateInput!) {
  saveMedigapFilterState(input: $input)
}
    `;
export type SaveMedigapFilterStateMutationFn = Apollo.MutationFunction<SaveMedigapFilterStateMutation, SaveMedigapFilterStateMutationVariables>;

/**
 * __useSaveMedigapFilterStateMutation__
 *
 * To run a mutation, you first call `useSaveMedigapFilterStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMedigapFilterStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMedigapFilterStateMutation, { data, loading, error }] = useSaveMedigapFilterStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMedigapFilterStateMutation(baseOptions?: Apollo.MutationHookOptions<SaveMedigapFilterStateMutation, SaveMedigapFilterStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMedigapFilterStateMutation, SaveMedigapFilterStateMutationVariables>(SaveMedigapFilterStateDocument, options);
      }
export type SaveMedigapFilterStateMutationHookResult = ReturnType<typeof useSaveMedigapFilterStateMutation>;
export type SaveMedigapFilterStateMutationResult = Apollo.MutationResult<SaveMedigapFilterStateMutation>;
export type SaveMedigapFilterStateMutationOptions = Apollo.BaseMutationOptions<SaveMedigapFilterStateMutation, SaveMedigapFilterStateMutationVariables>;
export const MedigapFiltersDocument = gql`
    query medigapFilters($filter: MedigapPlansFilterInput!) {
  medigapBenefits {
    key
    name
  }
  medigapMonthlyPlanPremium {
    key
    name
  }
  medigapPlanNames(filter: $filter) {
    key
    name
    count
  }
  medigapCompanies(filter: $filter) {
    key
    name
    count
    naics
  }
}
    `;

/**
 * __useMedigapFiltersQuery__
 *
 * To run a query within a React component, call `useMedigapFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapFiltersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMedigapFiltersQuery(baseOptions: Apollo.QueryHookOptions<MedigapFiltersQuery, MedigapFiltersQueryVariables> & ({ variables: MedigapFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapFiltersQuery, MedigapFiltersQueryVariables>(MedigapFiltersDocument, options);
      }
export function useMedigapFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapFiltersQuery, MedigapFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapFiltersQuery, MedigapFiltersQueryVariables>(MedigapFiltersDocument, options);
        }
export function useMedigapFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapFiltersQuery, MedigapFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapFiltersQuery, MedigapFiltersQueryVariables>(MedigapFiltersDocument, options);
        }
export type MedigapFiltersQueryHookResult = ReturnType<typeof useMedigapFiltersQuery>;
export type MedigapFiltersLazyQueryHookResult = ReturnType<typeof useMedigapFiltersLazyQuery>;
export type MedigapFiltersSuspenseQueryHookResult = ReturnType<typeof useMedigapFiltersSuspenseQuery>;
export type MedigapFiltersQueryResult = Apollo.QueryResult<MedigapFiltersQuery, MedigapFiltersQueryVariables>;
export const CreateMedigapQuoteFromMedicareQuoteDocument = gql`
    mutation createMedigapQuoteFromMedicareQuote($medicareQuoteId: UUID!) {
  createMedigapQuoteFromMedicareQuote(medicareQuoteId: $medicareQuoteId) {
    clientId
    mgQuoteId
  }
}
    `;
export type CreateMedigapQuoteFromMedicareQuoteMutationFn = Apollo.MutationFunction<CreateMedigapQuoteFromMedicareQuoteMutation, CreateMedigapQuoteFromMedicareQuoteMutationVariables>;

/**
 * __useCreateMedigapQuoteFromMedicareQuoteMutation__
 *
 * To run a mutation, you first call `useCreateMedigapQuoteFromMedicareQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMedigapQuoteFromMedicareQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMedigapQuoteFromMedicareQuoteMutation, { data, loading, error }] = useCreateMedigapQuoteFromMedicareQuoteMutation({
 *   variables: {
 *      medicareQuoteId: // value for 'medicareQuoteId'
 *   },
 * });
 */
export function useCreateMedigapQuoteFromMedicareQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateMedigapQuoteFromMedicareQuoteMutation, CreateMedigapQuoteFromMedicareQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMedigapQuoteFromMedicareQuoteMutation, CreateMedigapQuoteFromMedicareQuoteMutationVariables>(CreateMedigapQuoteFromMedicareQuoteDocument, options);
      }
export type CreateMedigapQuoteFromMedicareQuoteMutationHookResult = ReturnType<typeof useCreateMedigapQuoteFromMedicareQuoteMutation>;
export type CreateMedigapQuoteFromMedicareQuoteMutationResult = Apollo.MutationResult<CreateMedigapQuoteFromMedicareQuoteMutation>;
export type CreateMedigapQuoteFromMedicareQuoteMutationOptions = Apollo.BaseMutationOptions<CreateMedigapQuoteFromMedicareQuoteMutation, CreateMedigapQuoteFromMedicareQuoteMutationVariables>;
export const MedigapPremiumRangesDocument = gql`
    query medigapPremiumRanges($zip: String!, $tobacco: Boolean!, $age: Int!, $gender: CsgGender!) {
  medigapPremiumRanges(zip: $zip, tobacco: $tobacco, age: $age, gender: $gender) {
    planName
    rangeDescription
  }
}
    `;

/**
 * __useMedigapPremiumRangesQuery__
 *
 * To run a query within a React component, call `useMedigapPremiumRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapPremiumRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapPremiumRangesQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *      tobacco: // value for 'tobacco'
 *      age: // value for 'age'
 *      gender: // value for 'gender'
 *   },
 * });
 */
export function useMedigapPremiumRangesQuery(baseOptions: Apollo.QueryHookOptions<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables> & ({ variables: MedigapPremiumRangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>(MedigapPremiumRangesDocument, options);
      }
export function useMedigapPremiumRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>(MedigapPremiumRangesDocument, options);
        }
export function useMedigapPremiumRangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>(MedigapPremiumRangesDocument, options);
        }
export type MedigapPremiumRangesQueryHookResult = ReturnType<typeof useMedigapPremiumRangesQuery>;
export type MedigapPremiumRangesLazyQueryHookResult = ReturnType<typeof useMedigapPremiumRangesLazyQuery>;
export type MedigapPremiumRangesSuspenseQueryHookResult = ReturnType<typeof useMedigapPremiumRangesSuspenseQuery>;
export type MedigapPremiumRangesQueryResult = Apollo.QueryResult<MedigapPremiumRangesQuery, MedigapPremiumRangesQueryVariables>;
export const MedigapPlansDocument = gql`
    query medigapPlans($filter: MedigapPlansFilterInput!, $page: PageInput!, $sort: [MedigapPlansSortInput!]) {
  medigapPlans(filter: $filter, page: $page, sort: $sort) {
    data {
      amBestRating
      householdDiscount
      key
      monthlyPremium
      orgName
      parentOrgName
      title
      subTitle
      naic
      spRating
      ratingClass
      planName
      showAdditionalBenefitsDescription
      disclaimer
    }
    totalElements
  }
}
    `;

/**
 * __useMedigapPlansQuery__
 *
 * To run a query within a React component, call `useMedigapPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapPlansQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useMedigapPlansQuery(baseOptions: Apollo.QueryHookOptions<MedigapPlansQuery, MedigapPlansQueryVariables> & ({ variables: MedigapPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapPlansQuery, MedigapPlansQueryVariables>(MedigapPlansDocument, options);
      }
export function useMedigapPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapPlansQuery, MedigapPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapPlansQuery, MedigapPlansQueryVariables>(MedigapPlansDocument, options);
        }
export function useMedigapPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapPlansQuery, MedigapPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapPlansQuery, MedigapPlansQueryVariables>(MedigapPlansDocument, options);
        }
export type MedigapPlansQueryHookResult = ReturnType<typeof useMedigapPlansQuery>;
export type MedigapPlansLazyQueryHookResult = ReturnType<typeof useMedigapPlansLazyQuery>;
export type MedigapPlansSuspenseQueryHookResult = ReturnType<typeof useMedigapPlansSuspenseQuery>;
export type MedigapPlansQueryResult = Apollo.QueryResult<MedigapPlansQuery, MedigapPlansQueryVariables>;
export const SaveMedigapQuoteDocument = gql`
    mutation saveMedigapQuote($input: MedigapQuoteInput!) {
  saveMedigapQuote(input: $input) {
    clientId
    mgQuoteId
  }
}
    `;
export type SaveMedigapQuoteMutationFn = Apollo.MutationFunction<SaveMedigapQuoteMutation, SaveMedigapQuoteMutationVariables>;

/**
 * __useSaveMedigapQuoteMutation__
 *
 * To run a mutation, you first call `useSaveMedigapQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMedigapQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMedigapQuoteMutation, { data, loading, error }] = useSaveMedigapQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMedigapQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveMedigapQuoteMutation, SaveMedigapQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMedigapQuoteMutation, SaveMedigapQuoteMutationVariables>(SaveMedigapQuoteDocument, options);
      }
export type SaveMedigapQuoteMutationHookResult = ReturnType<typeof useSaveMedigapQuoteMutation>;
export type SaveMedigapQuoteMutationResult = Apollo.MutationResult<SaveMedigapQuoteMutation>;
export type SaveMedigapQuoteMutationOptions = Apollo.BaseMutationOptions<SaveMedigapQuoteMutation, SaveMedigapQuoteMutationVariables>;
export const MedigapCompanyDocument = gql`
    query medigapCompany($naic: String!) {
  medigapCompany(naic: $naic) {
    parentCompanyName
    name
  }
}
    `;

/**
 * __useMedigapCompanyQuery__
 *
 * To run a query within a React component, call `useMedigapCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapCompanyQuery({
 *   variables: {
 *      naic: // value for 'naic'
 *   },
 * });
 */
export function useMedigapCompanyQuery(baseOptions: Apollo.QueryHookOptions<MedigapCompanyQuery, MedigapCompanyQueryVariables> & ({ variables: MedigapCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapCompanyQuery, MedigapCompanyQueryVariables>(MedigapCompanyDocument, options);
      }
export function useMedigapCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapCompanyQuery, MedigapCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapCompanyQuery, MedigapCompanyQueryVariables>(MedigapCompanyDocument, options);
        }
export function useMedigapCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapCompanyQuery, MedigapCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapCompanyQuery, MedigapCompanyQueryVariables>(MedigapCompanyDocument, options);
        }
export type MedigapCompanyQueryHookResult = ReturnType<typeof useMedigapCompanyQuery>;
export type MedigapCompanyLazyQueryHookResult = ReturnType<typeof useMedigapCompanyLazyQuery>;
export type MedigapCompanySuspenseQueryHookResult = ReturnType<typeof useMedigapCompanySuspenseQuery>;
export type MedigapCompanyQueryResult = Apollo.QueryResult<MedigapCompanyQuery, MedigapCompanyQueryVariables>;
export const MedigapCompaniesDocument = gql`
    query medigapCompanies($filters: MedigapPlansFilterInput!) {
  medigapCompanies(filter: $filters) {
    key
    name
    count
    naics
  }
}
    `;

/**
 * __useMedigapCompaniesQuery__
 *
 * To run a query within a React component, call `useMedigapCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapCompaniesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useMedigapCompaniesQuery(baseOptions: Apollo.QueryHookOptions<MedigapCompaniesQuery, MedigapCompaniesQueryVariables> & ({ variables: MedigapCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>(MedigapCompaniesDocument, options);
      }
export function useMedigapCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>(MedigapCompaniesDocument, options);
        }
export function useMedigapCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>(MedigapCompaniesDocument, options);
        }
export type MedigapCompaniesQueryHookResult = ReturnType<typeof useMedigapCompaniesQuery>;
export type MedigapCompaniesLazyQueryHookResult = ReturnType<typeof useMedigapCompaniesLazyQuery>;
export type MedigapCompaniesSuspenseQueryHookResult = ReturnType<typeof useMedigapCompaniesSuspenseQuery>;
export type MedigapCompaniesQueryResult = Apollo.QueryResult<MedigapCompaniesQuery, MedigapCompaniesQueryVariables>;
export const MedigapQuoteDocument = gql`
    query medigapQuote($id: UUID!) {
  medigapQuote(id: $id) {
    cId
    id
    clientId
    drugDeliveryType
    preferredDrugs {
      dosageRxcui
      frequency
      productRxcui
      purchaseFrequency
      quantity
    }
    medigapFilterState {
      age
      benefits
      companies
      county
      effectiveDate
      gender
      id
      monthlyPlanPremiumRanges
      planCategory
      planNames
      tobacco
      zip
    }
    preferredPharmacies
    userId
  }
}
    `;

/**
 * __useMedigapQuoteQuery__
 *
 * To run a query within a React component, call `useMedigapQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedigapQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedigapQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedigapQuoteQuery(baseOptions: Apollo.QueryHookOptions<MedigapQuoteQuery, MedigapQuoteQueryVariables> & ({ variables: MedigapQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MedigapQuoteQuery, MedigapQuoteQueryVariables>(MedigapQuoteDocument, options);
      }
export function useMedigapQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedigapQuoteQuery, MedigapQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MedigapQuoteQuery, MedigapQuoteQueryVariables>(MedigapQuoteDocument, options);
        }
export function useMedigapQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MedigapQuoteQuery, MedigapQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MedigapQuoteQuery, MedigapQuoteQueryVariables>(MedigapQuoteDocument, options);
        }
export type MedigapQuoteQueryHookResult = ReturnType<typeof useMedigapQuoteQuery>;
export type MedigapQuoteLazyQueryHookResult = ReturnType<typeof useMedigapQuoteLazyQuery>;
export type MedigapQuoteSuspenseQueryHookResult = ReturnType<typeof useMedigapQuoteSuspenseQuery>;
export type MedigapQuoteQueryResult = Apollo.QueryResult<MedigapQuoteQuery, MedigapQuoteQueryVariables>;
export const UnderwritingQuestionSetDocument = gql`
    query underwritingQuestionSet($naic: String, $naics: [String!], $state: String) {
  underwritingQuestionSet(naic: $naic, naics: $naics, state: $state) {
    ...UnderwritingQuestionSetFields
    questions {
      ...UnderwritingQuestionFields
      children {
        ...UnderwritingQuestionFields
        children {
          ...UnderwritingQuestionFields
          children {
            ...UnderwritingQuestionFields
          }
        }
      }
    }
  }
}
    ${UnderwritingQuestionSetFieldsFragmentDoc}
${UnderwritingQuestionFieldsFragmentDoc}`;

/**
 * __useUnderwritingQuestionSetQuery__
 *
 * To run a query within a React component, call `useUnderwritingQuestionSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingQuestionSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingQuestionSetQuery({
 *   variables: {
 *      naic: // value for 'naic'
 *      naics: // value for 'naics'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUnderwritingQuestionSetQuery(baseOptions?: Apollo.QueryHookOptions<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>(UnderwritingQuestionSetDocument, options);
      }
export function useUnderwritingQuestionSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>(UnderwritingQuestionSetDocument, options);
        }
export function useUnderwritingQuestionSetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>(UnderwritingQuestionSetDocument, options);
        }
export type UnderwritingQuestionSetQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetQuery>;
export type UnderwritingQuestionSetLazyQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetLazyQuery>;
export type UnderwritingQuestionSetSuspenseQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetSuspenseQuery>;
export type UnderwritingQuestionSetQueryResult = Apollo.QueryResult<UnderwritingQuestionSetQuery, UnderwritingQuestionSetQueryVariables>;
export const UnderwritingQuestionSetsDocument = gql`
    query underwritingQuestionSets {
  underwritingQuestionSets {
    ...UnderwritingQuestionSetFields
    questions {
      id
    }
  }
}
    ${UnderwritingQuestionSetFieldsFragmentDoc}`;

/**
 * __useUnderwritingQuestionSetsQuery__
 *
 * To run a query within a React component, call `useUnderwritingQuestionSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingQuestionSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingQuestionSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnderwritingQuestionSetsQuery(baseOptions?: Apollo.QueryHookOptions<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>(UnderwritingQuestionSetsDocument, options);
      }
export function useUnderwritingQuestionSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>(UnderwritingQuestionSetsDocument, options);
        }
export function useUnderwritingQuestionSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>(UnderwritingQuestionSetsDocument, options);
        }
export type UnderwritingQuestionSetsQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetsQuery>;
export type UnderwritingQuestionSetsLazyQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetsLazyQuery>;
export type UnderwritingQuestionSetsSuspenseQueryHookResult = ReturnType<typeof useUnderwritingQuestionSetsSuspenseQuery>;
export type UnderwritingQuestionSetsQueryResult = Apollo.QueryResult<UnderwritingQuestionSetsQuery, UnderwritingQuestionSetsQueryVariables>;
export const UnderwritingAnswersDocument = gql`
    query underwritingAnswers($clientId: UUID!, $naic: String) {
  underwritingAnswers(clientId: $clientId, naic: $naic) {
    ...UnderwritingAnswerFields
  }
}
    ${UnderwritingAnswerFieldsFragmentDoc}`;

/**
 * __useUnderwritingAnswersQuery__
 *
 * To run a query within a React component, call `useUnderwritingAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingAnswersQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      naic: // value for 'naic'
 *   },
 * });
 */
export function useUnderwritingAnswersQuery(baseOptions: Apollo.QueryHookOptions<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables> & ({ variables: UnderwritingAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>(UnderwritingAnswersDocument, options);
      }
export function useUnderwritingAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>(UnderwritingAnswersDocument, options);
        }
export function useUnderwritingAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>(UnderwritingAnswersDocument, options);
        }
export type UnderwritingAnswersQueryHookResult = ReturnType<typeof useUnderwritingAnswersQuery>;
export type UnderwritingAnswersLazyQueryHookResult = ReturnType<typeof useUnderwritingAnswersLazyQuery>;
export type UnderwritingAnswersSuspenseQueryHookResult = ReturnType<typeof useUnderwritingAnswersSuspenseQuery>;
export type UnderwritingAnswersQueryResult = Apollo.QueryResult<UnderwritingAnswersQuery, UnderwritingAnswersQueryVariables>;
export const SaveUnderwritingAnswersDocument = gql`
    mutation saveUnderwritingAnswers($input: SaveUnderwritingAnswersInput!) {
  saveUnderwritingAnswers(input: $input) {
    ...UnderwritingAnswerFields
  }
}
    ${UnderwritingAnswerFieldsFragmentDoc}`;
export type SaveUnderwritingAnswersMutationFn = Apollo.MutationFunction<SaveUnderwritingAnswersMutation, SaveUnderwritingAnswersMutationVariables>;

/**
 * __useSaveUnderwritingAnswersMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingAnswersMutation, { data, loading, error }] = useSaveUnderwritingAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnderwritingAnswersMutation, SaveUnderwritingAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnderwritingAnswersMutation, SaveUnderwritingAnswersMutationVariables>(SaveUnderwritingAnswersDocument, options);
      }
export type SaveUnderwritingAnswersMutationHookResult = ReturnType<typeof useSaveUnderwritingAnswersMutation>;
export type SaveUnderwritingAnswersMutationResult = Apollo.MutationResult<SaveUnderwritingAnswersMutation>;
export type SaveUnderwritingAnswersMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingAnswersMutation, SaveUnderwritingAnswersMutationVariables>;
export const DeleteUnderwritingAnswerDocument = gql`
    mutation deleteUnderwritingAnswer($id: UUID!) {
  deleteUnderwritingAnswer(id: $id)
}
    `;
export type DeleteUnderwritingAnswerMutationFn = Apollo.MutationFunction<DeleteUnderwritingAnswerMutation, DeleteUnderwritingAnswerMutationVariables>;

/**
 * __useDeleteUnderwritingAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteUnderwritingAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnderwritingAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnderwritingAnswerMutation, { data, loading, error }] = useDeleteUnderwritingAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnderwritingAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnderwritingAnswerMutation, DeleteUnderwritingAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnderwritingAnswerMutation, DeleteUnderwritingAnswerMutationVariables>(DeleteUnderwritingAnswerDocument, options);
      }
export type DeleteUnderwritingAnswerMutationHookResult = ReturnType<typeof useDeleteUnderwritingAnswerMutation>;
export type DeleteUnderwritingAnswerMutationResult = Apollo.MutationResult<DeleteUnderwritingAnswerMutation>;
export type DeleteUnderwritingAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteUnderwritingAnswerMutation, DeleteUnderwritingAnswerMutationVariables>;
export const DisableUnderwritingAnswersForCarrierDocument = gql`
    mutation disableUnderwritingAnswersForCarrier($clientId: UUID!, $naic: String!) {
  disableUnderwritingAnswersForCarrier(clientId: $clientId, naic: $naic)
}
    `;
export type DisableUnderwritingAnswersForCarrierMutationFn = Apollo.MutationFunction<DisableUnderwritingAnswersForCarrierMutation, DisableUnderwritingAnswersForCarrierMutationVariables>;

/**
 * __useDisableUnderwritingAnswersForCarrierMutation__
 *
 * To run a mutation, you first call `useDisableUnderwritingAnswersForCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUnderwritingAnswersForCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUnderwritingAnswersForCarrierMutation, { data, loading, error }] = useDisableUnderwritingAnswersForCarrierMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      naic: // value for 'naic'
 *   },
 * });
 */
export function useDisableUnderwritingAnswersForCarrierMutation(baseOptions?: Apollo.MutationHookOptions<DisableUnderwritingAnswersForCarrierMutation, DisableUnderwritingAnswersForCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUnderwritingAnswersForCarrierMutation, DisableUnderwritingAnswersForCarrierMutationVariables>(DisableUnderwritingAnswersForCarrierDocument, options);
      }
export type DisableUnderwritingAnswersForCarrierMutationHookResult = ReturnType<typeof useDisableUnderwritingAnswersForCarrierMutation>;
export type DisableUnderwritingAnswersForCarrierMutationResult = Apollo.MutationResult<DisableUnderwritingAnswersForCarrierMutation>;
export type DisableUnderwritingAnswersForCarrierMutationOptions = Apollo.BaseMutationOptions<DisableUnderwritingAnswersForCarrierMutation, DisableUnderwritingAnswersForCarrierMutationVariables>;
export const SaveUnderwritingQuestionSetDocument = gql`
    mutation saveUnderwritingQuestionSet($input: UnderwritingQuestionSetInput!) {
  saveUnderwritingQuestionSet(input: $input)
}
    `;
export type SaveUnderwritingQuestionSetMutationFn = Apollo.MutationFunction<SaveUnderwritingQuestionSetMutation, SaveUnderwritingQuestionSetMutationVariables>;

/**
 * __useSaveUnderwritingQuestionSetMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingQuestionSetMutation, { data, loading, error }] = useSaveUnderwritingQuestionSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnderwritingQuestionSetMutation, SaveUnderwritingQuestionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnderwritingQuestionSetMutation, SaveUnderwritingQuestionSetMutationVariables>(SaveUnderwritingQuestionSetDocument, options);
      }
export type SaveUnderwritingQuestionSetMutationHookResult = ReturnType<typeof useSaveUnderwritingQuestionSetMutation>;
export type SaveUnderwritingQuestionSetMutationResult = Apollo.MutationResult<SaveUnderwritingQuestionSetMutation>;
export type SaveUnderwritingQuestionSetMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingQuestionSetMutation, SaveUnderwritingQuestionSetMutationVariables>;
export const SaveUnderwritingQuestionDocument = gql`
    mutation saveUnderwritingQuestion($input: UnderwritingQuestionInput!) {
  saveUnderwritingQuestion(input: $input)
}
    `;
export type SaveUnderwritingQuestionMutationFn = Apollo.MutationFunction<SaveUnderwritingQuestionMutation, SaveUnderwritingQuestionMutationVariables>;

/**
 * __useSaveUnderwritingQuestionMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingQuestionMutation, { data, loading, error }] = useSaveUnderwritingQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingQuestionMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnderwritingQuestionMutation, SaveUnderwritingQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnderwritingQuestionMutation, SaveUnderwritingQuestionMutationVariables>(SaveUnderwritingQuestionDocument, options);
      }
export type SaveUnderwritingQuestionMutationHookResult = ReturnType<typeof useSaveUnderwritingQuestionMutation>;
export type SaveUnderwritingQuestionMutationResult = Apollo.MutationResult<SaveUnderwritingQuestionMutation>;
export type SaveUnderwritingQuestionMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingQuestionMutation, SaveUnderwritingQuestionMutationVariables>;
export const DeleteUnderwritingQuestionSetDocument = gql`
    mutation deleteUnderwritingQuestionSet($id: UUID!) {
  deleteUnderwritingQuestionSet(id: $id)
}
    `;
export type DeleteUnderwritingQuestionSetMutationFn = Apollo.MutationFunction<DeleteUnderwritingQuestionSetMutation, DeleteUnderwritingQuestionSetMutationVariables>;

/**
 * __useDeleteUnderwritingQuestionSetMutation__
 *
 * To run a mutation, you first call `useDeleteUnderwritingQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnderwritingQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnderwritingQuestionSetMutation, { data, loading, error }] = useDeleteUnderwritingQuestionSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnderwritingQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnderwritingQuestionSetMutation, DeleteUnderwritingQuestionSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnderwritingQuestionSetMutation, DeleteUnderwritingQuestionSetMutationVariables>(DeleteUnderwritingQuestionSetDocument, options);
      }
export type DeleteUnderwritingQuestionSetMutationHookResult = ReturnType<typeof useDeleteUnderwritingQuestionSetMutation>;
export type DeleteUnderwritingQuestionSetMutationResult = Apollo.MutationResult<DeleteUnderwritingQuestionSetMutation>;
export type DeleteUnderwritingQuestionSetMutationOptions = Apollo.BaseMutationOptions<DeleteUnderwritingQuestionSetMutation, DeleteUnderwritingQuestionSetMutationVariables>;
export const DeleteUnderwritingQuestionDocument = gql`
    mutation deleteUnderwritingQuestion($id: UUID!) {
  deleteUnderwritingQuestion(id: $id)
}
    `;
export type DeleteUnderwritingQuestionMutationFn = Apollo.MutationFunction<DeleteUnderwritingQuestionMutation, DeleteUnderwritingQuestionMutationVariables>;

/**
 * __useDeleteUnderwritingQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteUnderwritingQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnderwritingQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnderwritingQuestionMutation, { data, loading, error }] = useDeleteUnderwritingQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnderwritingQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnderwritingQuestionMutation, DeleteUnderwritingQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnderwritingQuestionMutation, DeleteUnderwritingQuestionMutationVariables>(DeleteUnderwritingQuestionDocument, options);
      }
export type DeleteUnderwritingQuestionMutationHookResult = ReturnType<typeof useDeleteUnderwritingQuestionMutation>;
export type DeleteUnderwritingQuestionMutationResult = Apollo.MutationResult<DeleteUnderwritingQuestionMutation>;
export type DeleteUnderwritingQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteUnderwritingQuestionMutation, DeleteUnderwritingQuestionMutationVariables>;
export const DeclinableDrugListDocument = gql`
    query declinableDrugList($naics: [String!]) {
  declinableDrugList(naics: $naics) {
    ...DeclinableDrugListFields
  }
}
    ${DeclinableDrugListFieldsFragmentDoc}`;

/**
 * __useDeclinableDrugListQuery__
 *
 * To run a query within a React component, call `useDeclinableDrugListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclinableDrugListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclinableDrugListQuery({
 *   variables: {
 *      naics: // value for 'naics'
 *   },
 * });
 */
export function useDeclinableDrugListQuery(baseOptions?: Apollo.QueryHookOptions<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>(DeclinableDrugListDocument, options);
      }
export function useDeclinableDrugListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>(DeclinableDrugListDocument, options);
        }
export function useDeclinableDrugListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>(DeclinableDrugListDocument, options);
        }
export type DeclinableDrugListQueryHookResult = ReturnType<typeof useDeclinableDrugListQuery>;
export type DeclinableDrugListLazyQueryHookResult = ReturnType<typeof useDeclinableDrugListLazyQuery>;
export type DeclinableDrugListSuspenseQueryHookResult = ReturnType<typeof useDeclinableDrugListSuspenseQuery>;
export type DeclinableDrugListQueryResult = Apollo.QueryResult<DeclinableDrugListQuery, DeclinableDrugListQueryVariables>;
export const DeclinableDrugListsDocument = gql`
    query declinableDrugLists {
  declinableDrugLists {
    ...DeclinableDrugListFields
  }
}
    ${DeclinableDrugListFieldsFragmentDoc}`;

/**
 * __useDeclinableDrugListsQuery__
 *
 * To run a query within a React component, call `useDeclinableDrugListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclinableDrugListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclinableDrugListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeclinableDrugListsQuery(baseOptions?: Apollo.QueryHookOptions<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>(DeclinableDrugListsDocument, options);
      }
export function useDeclinableDrugListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>(DeclinableDrugListsDocument, options);
        }
export function useDeclinableDrugListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>(DeclinableDrugListsDocument, options);
        }
export type DeclinableDrugListsQueryHookResult = ReturnType<typeof useDeclinableDrugListsQuery>;
export type DeclinableDrugListsLazyQueryHookResult = ReturnType<typeof useDeclinableDrugListsLazyQuery>;
export type DeclinableDrugListsSuspenseQueryHookResult = ReturnType<typeof useDeclinableDrugListsSuspenseQuery>;
export type DeclinableDrugListsQueryResult = Apollo.QueryResult<DeclinableDrugListsQuery, DeclinableDrugListsQueryVariables>;
export const SaveDeclinableDrugListDocument = gql`
    mutation saveDeclinableDrugList($input: DeclinableDrugListInput!) {
  saveDeclinableDrugList(input: $input)
}
    `;
export type SaveDeclinableDrugListMutationFn = Apollo.MutationFunction<SaveDeclinableDrugListMutation, SaveDeclinableDrugListMutationVariables>;

/**
 * __useSaveDeclinableDrugListMutation__
 *
 * To run a mutation, you first call `useSaveDeclinableDrugListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeclinableDrugListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeclinableDrugListMutation, { data, loading, error }] = useSaveDeclinableDrugListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDeclinableDrugListMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeclinableDrugListMutation, SaveDeclinableDrugListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeclinableDrugListMutation, SaveDeclinableDrugListMutationVariables>(SaveDeclinableDrugListDocument, options);
      }
export type SaveDeclinableDrugListMutationHookResult = ReturnType<typeof useSaveDeclinableDrugListMutation>;
export type SaveDeclinableDrugListMutationResult = Apollo.MutationResult<SaveDeclinableDrugListMutation>;
export type SaveDeclinableDrugListMutationOptions = Apollo.BaseMutationOptions<SaveDeclinableDrugListMutation, SaveDeclinableDrugListMutationVariables>;
export const DeleteDeclinableDrugListDocument = gql`
    mutation deleteDeclinableDrugList($id: UUID!) {
  deleteDeclinableDrugList(id: $id)
}
    `;
export type DeleteDeclinableDrugListMutationFn = Apollo.MutationFunction<DeleteDeclinableDrugListMutation, DeleteDeclinableDrugListMutationVariables>;

/**
 * __useDeleteDeclinableDrugListMutation__
 *
 * To run a mutation, you first call `useDeleteDeclinableDrugListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeclinableDrugListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeclinableDrugListMutation, { data, loading, error }] = useDeleteDeclinableDrugListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeclinableDrugListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeclinableDrugListMutation, DeleteDeclinableDrugListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeclinableDrugListMutation, DeleteDeclinableDrugListMutationVariables>(DeleteDeclinableDrugListDocument, options);
      }
export type DeleteDeclinableDrugListMutationHookResult = ReturnType<typeof useDeleteDeclinableDrugListMutation>;
export type DeleteDeclinableDrugListMutationResult = Apollo.MutationResult<DeleteDeclinableDrugListMutation>;
export type DeleteDeclinableDrugListMutationOptions = Apollo.BaseMutationOptions<DeleteDeclinableDrugListMutation, DeleteDeclinableDrugListMutationVariables>;
export const SaveDeclinableDrugDocument = gql`
    mutation saveDeclinableDrug($input: DeclinableDrugInput!) {
  saveDeclinableDrug(input: $input)
}
    `;
export type SaveDeclinableDrugMutationFn = Apollo.MutationFunction<SaveDeclinableDrugMutation, SaveDeclinableDrugMutationVariables>;

/**
 * __useSaveDeclinableDrugMutation__
 *
 * To run a mutation, you first call `useSaveDeclinableDrugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeclinableDrugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeclinableDrugMutation, { data, loading, error }] = useSaveDeclinableDrugMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDeclinableDrugMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeclinableDrugMutation, SaveDeclinableDrugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeclinableDrugMutation, SaveDeclinableDrugMutationVariables>(SaveDeclinableDrugDocument, options);
      }
export type SaveDeclinableDrugMutationHookResult = ReturnType<typeof useSaveDeclinableDrugMutation>;
export type SaveDeclinableDrugMutationResult = Apollo.MutationResult<SaveDeclinableDrugMutation>;
export type SaveDeclinableDrugMutationOptions = Apollo.BaseMutationOptions<SaveDeclinableDrugMutation, SaveDeclinableDrugMutationVariables>;
export const DeleteDeclinableDrugDocument = gql`
    mutation deleteDeclinableDrug($id: UUID!) {
  deleteDeclinableDrug(id: $id)
}
    `;
export type DeleteDeclinableDrugMutationFn = Apollo.MutationFunction<DeleteDeclinableDrugMutation, DeleteDeclinableDrugMutationVariables>;

/**
 * __useDeleteDeclinableDrugMutation__
 *
 * To run a mutation, you first call `useDeleteDeclinableDrugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeclinableDrugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeclinableDrugMutation, { data, loading, error }] = useDeleteDeclinableDrugMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDeclinableDrugMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeclinableDrugMutation, DeleteDeclinableDrugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeclinableDrugMutation, DeleteDeclinableDrugMutationVariables>(DeleteDeclinableDrugDocument, options);
      }
export type DeleteDeclinableDrugMutationHookResult = ReturnType<typeof useDeleteDeclinableDrugMutation>;
export type DeleteDeclinableDrugMutationResult = Apollo.MutationResult<DeleteDeclinableDrugMutation>;
export type DeleteDeclinableDrugMutationOptions = Apollo.BaseMutationOptions<DeleteDeclinableDrugMutation, DeleteDeclinableDrugMutationVariables>;
export const UnderwritingClientNoteDocument = gql`
    query underwritingClientNote($clientId: UUID!, $naic: String!) {
  underwritingClientNote(clientId: $clientId, naic: $naic) {
    ...UnderwritingClientNoteFields
  }
}
    ${UnderwritingClientNoteFieldsFragmentDoc}`;

/**
 * __useUnderwritingClientNoteQuery__
 *
 * To run a query within a React component, call `useUnderwritingClientNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingClientNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingClientNoteQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      naic: // value for 'naic'
 *   },
 * });
 */
export function useUnderwritingClientNoteQuery(baseOptions: Apollo.QueryHookOptions<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables> & ({ variables: UnderwritingClientNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>(UnderwritingClientNoteDocument, options);
      }
export function useUnderwritingClientNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>(UnderwritingClientNoteDocument, options);
        }
export function useUnderwritingClientNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>(UnderwritingClientNoteDocument, options);
        }
export type UnderwritingClientNoteQueryHookResult = ReturnType<typeof useUnderwritingClientNoteQuery>;
export type UnderwritingClientNoteLazyQueryHookResult = ReturnType<typeof useUnderwritingClientNoteLazyQuery>;
export type UnderwritingClientNoteSuspenseQueryHookResult = ReturnType<typeof useUnderwritingClientNoteSuspenseQuery>;
export type UnderwritingClientNoteQueryResult = Apollo.QueryResult<UnderwritingClientNoteQuery, UnderwritingClientNoteQueryVariables>;
export const SaveUnderwritingClientNoteDocument = gql`
    mutation saveUnderwritingClientNote($input: SaveUnderwritingClientNoteInput!) {
  saveUnderwritingClientNote(input: $input) {
    ...UnderwritingClientNoteFields
  }
}
    ${UnderwritingClientNoteFieldsFragmentDoc}`;
export type SaveUnderwritingClientNoteMutationFn = Apollo.MutationFunction<SaveUnderwritingClientNoteMutation, SaveUnderwritingClientNoteMutationVariables>;

/**
 * __useSaveUnderwritingClientNoteMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingClientNoteMutation, { data, loading, error }] = useSaveUnderwritingClientNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnderwritingClientNoteMutation, SaveUnderwritingClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnderwritingClientNoteMutation, SaveUnderwritingClientNoteMutationVariables>(SaveUnderwritingClientNoteDocument, options);
      }
export type SaveUnderwritingClientNoteMutationHookResult = ReturnType<typeof useSaveUnderwritingClientNoteMutation>;
export type SaveUnderwritingClientNoteMutationResult = Apollo.MutationResult<SaveUnderwritingClientNoteMutation>;
export type SaveUnderwritingClientNoteMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingClientNoteMutation, SaveUnderwritingClientNoteMutationVariables>;
export const DeclinableDrugAnswersDocument = gql`
    query declinableDrugAnswers($clientId: UUID!, $naic: String!) {
  declinableDrugAnswers(clientId: $clientId, naic: $naic) {
    ...DeclinableDrugAnswerFields
  }
}
    ${DeclinableDrugAnswerFieldsFragmentDoc}`;

/**
 * __useDeclinableDrugAnswersQuery__
 *
 * To run a query within a React component, call `useDeclinableDrugAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclinableDrugAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclinableDrugAnswersQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      naic: // value for 'naic'
 *   },
 * });
 */
export function useDeclinableDrugAnswersQuery(baseOptions: Apollo.QueryHookOptions<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables> & ({ variables: DeclinableDrugAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>(DeclinableDrugAnswersDocument, options);
      }
export function useDeclinableDrugAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>(DeclinableDrugAnswersDocument, options);
        }
export function useDeclinableDrugAnswersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>(DeclinableDrugAnswersDocument, options);
        }
export type DeclinableDrugAnswersQueryHookResult = ReturnType<typeof useDeclinableDrugAnswersQuery>;
export type DeclinableDrugAnswersLazyQueryHookResult = ReturnType<typeof useDeclinableDrugAnswersLazyQuery>;
export type DeclinableDrugAnswersSuspenseQueryHookResult = ReturnType<typeof useDeclinableDrugAnswersSuspenseQuery>;
export type DeclinableDrugAnswersQueryResult = Apollo.QueryResult<DeclinableDrugAnswersQuery, DeclinableDrugAnswersQueryVariables>;
export const SaveDeclinableDrugAnswersDocument = gql`
    mutation saveDeclinableDrugAnswers($input: SaveDeclinableDrugAnswersInput!) {
  saveDeclinableDrugAnswers(input: $input) {
    ...DeclinableDrugAnswerFields
  }
}
    ${DeclinableDrugAnswerFieldsFragmentDoc}`;
export type SaveDeclinableDrugAnswersMutationFn = Apollo.MutationFunction<SaveDeclinableDrugAnswersMutation, SaveDeclinableDrugAnswersMutationVariables>;

/**
 * __useSaveDeclinableDrugAnswersMutation__
 *
 * To run a mutation, you first call `useSaveDeclinableDrugAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeclinableDrugAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeclinableDrugAnswersMutation, { data, loading, error }] = useSaveDeclinableDrugAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDeclinableDrugAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeclinableDrugAnswersMutation, SaveDeclinableDrugAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeclinableDrugAnswersMutation, SaveDeclinableDrugAnswersMutationVariables>(SaveDeclinableDrugAnswersDocument, options);
      }
export type SaveDeclinableDrugAnswersMutationHookResult = ReturnType<typeof useSaveDeclinableDrugAnswersMutation>;
export type SaveDeclinableDrugAnswersMutationResult = Apollo.MutationResult<SaveDeclinableDrugAnswersMutation>;
export type SaveDeclinableDrugAnswersMutationOptions = Apollo.BaseMutationOptions<SaveDeclinableDrugAnswersMutation, SaveDeclinableDrugAnswersMutationVariables>;